<template>
  <div>
    <h3>
      Memberships
      <span
        v-if="sendToAllMembers"
        v-text="'(All Members)'"
      />
      <span
        v-else
        v-text="`(${selectedMemberships.length})`"
      />
    </h3>
    <div class="flex justify-center items-baseline mt-4">
      <div class="input-group flex-1">
        <input
          v-model="search"
          class="recipientFilter"
          placeholder="Filter memberships"
          type="text"
        >
      </div>
      <div class="text-xs pl-4">
        <a
          href="#"
          @click.prevent="selectAll"
          v-text="'Select All'"
        />
        <span
          class="mx-2"
          v-text="'|'"
        />
        <a
          href="#"
          @click.prevent="selectNone"
          v-text="'Select None'"
        />
      </div>
    </div>
    <ul
      v-show="memberships.length"
      ref="membershipsList"
      class="scroll-checklist scroll-blue"
    >
      <li>
        <input
          id="send_to_all_members"
          v-model="sendToAllMembers"
          value="send_to_all_members"
          type="checkbox"
          name="send_to_all_members"
        >
        <label
          for="send_to_all_members"
          class="checkbox"
          v-text="'Send to All Members'"
        />
      </li>
      <li
        v-for="membership in memberships"
        :key="membership.uuid"
        :class="{ 'does-not-receive-communications': !receivesCommunication(membership) || sendToAllMembers }"
        :title="!receivesCommunication(membership) ? 'Member does not receive this type of communication.' : ''"
      >
        <input
          :id="membership.uuid"
          v-model="selectedMemberships"
          :disabled="!receivesCommunication(membership) || sendToAllMembers"
          :aria-disabled="!receivesCommunication(membership) || sendToAllMembers"
          :value="membership.uuid"
          type="checkbox"
          :name="membership.uuid"
        >
        <label
          :for="membership.uuid"
          class="checkbox"
          v-text="membership.attributes.full_name"
        />
      </li>
    </ul>
    <ul
      v-show="memberships.length == 0"
      class="list-reset"
    >
      <li>
        <small>No results for "{{ search }}"</small>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'RecipientMembershipSelector',
  model: {
    prop: 'selectedMembershipUuids',
  },
  props: {
    selectedMembershipUuids: {
      type: Array,
      required: false,
      default: () => [],
    },
    communicationMode: {
      type: String,
      required: true,
    },
    sendToAllMembersProp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedMemberships: [],
      search: '',
      sendToAllMembers: this.sendToAllMembersProp,
      memberships: [],
      membershipsPage: 1,
      isLoading: false,
    }
  },
  watch: {
    selectedMembershipUuids(newVal) {
      if (newVal !== this.selectedMemberships) {
        this.selectedMemberships = newVal
      }
    },
    selectedMemberships() {
      this.$emit('input', this.selectedMemberships)
    },
    search: debounce(function () {
      this.membershipsPage = 1

      this.$api.active().get('memberships', {
        params: {
          include: 'phoneNumbers',
          query: this.search,
          per_page: 100,
        },
      }).then((response) => {
        this.memberships = response.data.data
      })
    }, 500),
    sendToAllMembers(newVal) {
      if (newVal) {
        this.selectedMemberships = [
          'send_to_all_members',
        ]
      } else {
        this.selectedMemberships = []
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.$api.active().get('memberships', {
        params: {
          include: 'phoneNumbers',
          per_page: 100,
        },
      }).then((response) => {
        this.memberships = response.data.data

        this.$nextTick( ()  => {
          this.$refs.membershipsList.onscroll = () => {
            const bottomOfMembershipsList = this.$refs.membershipsList.scrollTop + this.$refs.membershipsList.clientHeight  >  (this.$refs.membershipsList.scrollHeight -20)

            if (bottomOfMembershipsList && !this.isLoading) {
              this.nextMembershipsPage()
            }
          }
        })
      })

      this.selectedMemberships = this.selectedMembershipUuids
    })
  },
  methods: {
    receivesCommunication(membership) {
      if (this.communicationMode === 'sms') {
        return _.find(membership.phoneNumbers.data, function (phoneNumber) {
          return phoneNumber.attributes.textable
        })
      } else {
        return membership.attributes.accepts_email_communication
      }
    },
    nextMembershipsPage() {
      if(this.search.length === 0) {
        this.isLoading = true
        this.$api.active().get('memberships', {
          params: {
            include: 'phoneNumbers',
            per_page: 100,
            page : ++ this.membershipsPage,
          },
        }).then((response) => {
          this.isLoading = false
          this.memberships = this.memberships.concat(response.data.data)
        })
      }
    },
    selectAll() {
      if (this.sendToAllMembers) {
        return false
      }

      const vm = this

      this.selectedMemberships = _.map(
        _.filter(this.memberships, function (membership) {
          if (vm.communicationMode === 'sms') {
            return _.find(membership.phoneNumbers.data, function (phoneNumber) {
              return phoneNumber.attributes.textable
            })
          } else {
            return membership.attributes.accepts_email_communication
          }
        }), 'uuid')
    },
    selectNone() {
      this.selectedMemberships = []
      this.sendToAllMembers = false
    },
  },
}
</script>

<style>
.recipientFilter {
  margin-bottom: 0 !important;
}
</style>
